import {debugLog} from "../Utils/LogUtils";
import React, { useState } from 'react';
import InputRowGroup from "../DataCollection/Inputs/InputRowGroup";
import TextInput from "../DataCollection/Inputs/TextInput";
import PasswordInput from "../DataCollection/Inputs/PasswordInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import DropdownInput from "../DataCollection/Inputs/DropdownInput";

const provinces = [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Nova Scotia",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Northwest Territories",
    "Nunavut",
    "Yukon"
];

const RegistrationForm = () => {
    const [error, setError] = useState('')
    const [registrationData, setRegistrationData] = useState({
        username: 'greg@verticalaim.com',
        firstName: 'Greg',
        lastName: 'McMullin',
        code: '1234',
        province: 'ON',
        password: 'password1234!',
        confirmPassword: 'password1234!'
    });

    function register() {
        setError('');
        //TODO: This whole page shouldn't even exist anymore since we are registering users though auth against the CET system
        fetch(process.env.REACT_APP_BACKEND_URL+'/auth/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                username: registrationData.username,
                firstName: registrationData.firstName,
                lastName: registrationData.lastName,
                agentCodes: [{
                    code: registrationData.code,
                    province: registrationData.province
                }],
                password: registrationData.password,
            })
        }).then(response => {
            if (response.ok) {
                debugLog(response); // Handle success response
            } else {
                setError(response);
                throw new Error('Network response was not ok.');
            }
            return response.json();
        }).then(result_data => {
            setError(result_data.msg);
            debugLog(result_data); // Handle success response
        }).catch(error => {
            console.error('There was a problem with your fetch operation:', error);
        })
    }

    return (
        <div>
            <h1>Registration Form</h1>
            <InputRowGroup>
                <InputRowGroup>
                    <TextInput id="username" name="username" placeholder={"Username"} state={registrationData} onChange={handleChange(setRegistrationData)} />
                </InputRowGroup>
                <InputRowGroup>
                    <TextInput id="firstName" name="firstName" placeholder={"First Name"} state={registrationData} onChange={handleChange(setRegistrationData)} />
                </InputRowGroup>
                <InputRowGroup>
                    <TextInput id="lastName" name="lastName" placeholder={"Last Name"} state={registrationData} onChange={handleChange(setRegistrationData)} />
                </InputRowGroup>
                <InputRowGroup>
                    <TextInput id="code" name="code" placeholder={"Agent Code"} state={registrationData} onChange={handleChange(setRegistrationData)} />
                </InputRowGroup>
                <InputRowGroup>
                    <DropdownInput
                        name={"province"}
                        state={registrationData}
                        onChange={handleChange(setRegistrationData)}
                        options={provinces.map(province => {
                            return { label: province, value: province };
                        })}
                    />
                </InputRowGroup>
                <InputRowGroup>
                    <PasswordInput id="password" name="password" placeholder={"Password"} state={registrationData} onChange={handleChange(setRegistrationData)} />
                </InputRowGroup>
                <InputRowGroup>
                    <PasswordInput id="confirmPassword" name="confirmPassword" placeholder={"Confirm Password"} state={registrationData}  onChange={handleChange(setRegistrationData)} />
                </InputRowGroup>
            </InputRowGroup>

            <div>{error}</div>

            <button onClick={register}>Register</button>
        </div>
    )
}

export default RegistrationForm;